(function() {
  const STORAGE_KEY = 'ezshop_wishlist';

  function getWishlist() {
    try {
      const items = localStorage.getItem(STORAGE_KEY);
      return items ? JSON.parse(items) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    updateWishlistUI();
  }

  function isInWishlist(handle) {
    const list = getWishlist();
    return list.some(item => item.handle === handle);
  }

  function toggleWishlist(product) {
    let list = getWishlist();
    const index = list.findIndex(item => item.handle === product.handle);

    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.unshift(product);
    }

    saveWishlist(list);
  }

  function updateWishlistUI() {
    const list = getWishlist();
    const count = list.length;

    // 1. Update Badges
    const badgeHeaders = document.querySelectorAll('[data-wishlist-count]');
    const badgeWrappers = document.querySelectorAll('[data-wishlist-count-wrapper]');
    const badgeInners = document.querySelectorAll('[data-wishlist-count-inner]');

    badgeHeaders.forEach(badge => {
      badge.textContent = count;
    });

    badgeWrappers.forEach(wrapper => {
      if (count > 0) {
        wrapper.classList.remove('is-hidden');
      } else {
        wrapper.classList.add('is-hidden');
      }
    });

    badgeInners.forEach(badge => {
      badge.textContent = count;
    });

    // 2. Update Heart Buttons on page
    const buttons = document.querySelectorAll('[data-wishlist-btn]');
    buttons.forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      if (isInWishlist(handle)) {
        btn.classList.add('is-in-wishlist');
        btn.setAttribute('aria-label', 'Favorilerden Çıkar');
        btn.setAttribute('title', 'Favorilerden Çıkar');
      } else {
        btn.classList.remove('is-in-wishlist');
        btn.setAttribute('aria-label', 'Favorilere Ekle');
        btn.setAttribute('title', 'Favorilere Ekle');
      }
    });

    // 3. Render Items in Drawer
    const itemsContainer = document.querySelector('[data-wishlist-items]');
    const emptyState = document.querySelector('[data-wishlist-empty]');

    if (itemsContainer && emptyState) {
      if (count === 0) {
        itemsContainer.innerHTML = '';
        emptyState.classList.add('is-visible');
      } else {
        emptyState.classList.remove('is-visible');
        itemsContainer.innerHTML = list.map(item => `
          <div class="tshirt-wishlist-item" data-wishlist-item-handle="${item.handle}">
            <div class="tshirt-wishlist-item-img">
              <img src="${item.img}" alt="${item.title}" width="56" height="56" loading="lazy">
            </div>
            <div class="tshirt-wishlist-item-info">
              <a href="${item.url}" class="tshirt-wishlist-item-title">${item.title}</a>
              <span class="tshirt-wishlist-item-price">${item.price}</span>
              <div class="tshirt-wishlist-item-actions">
                <a href="${item.url}" class="tshirt-wishlist-add-btn">Ürünü İncele</a>
                <button type="button" class="tshirt-wishlist-remove-btn" data-wishlist-remove-handle="${item.handle}" aria-label="Kaldır">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        `).join('');
      }
    }
  }

  function openWishlistDrawer() {
    const drawer = document.getElementById('tshirt-wishlist-drawer');
    if (drawer) {
      updateWishlistUI();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
    }
  }

  function closeWishlistDrawer() {
    const drawer = document.getElementById('tshirt-wishlist-drawer');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    }
  }

  function initWishlist() {
    updateWishlistUI();

    // Global Click Delegation
    document.addEventListener('click', function(e) {
      // 1. Wishlist Button Click
      const btn = e.target.closest('[data-wishlist-btn]');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();

        const product = {
          handle: btn.getAttribute('data-product-handle'),
          id: btn.getAttribute('data-product-id'),
          title: btn.getAttribute('data-product-title'),
          price: btn.getAttribute('data-product-price'),
          img: btn.getAttribute('data-product-img'),
          url: btn.getAttribute('data-product-url')
        };

        toggleWishlist(product);
        return;
      }

      // 2. Open Drawer Trigger
      const openTrigger = e.target.closest('[data-wishlist-drawer-trigger]');
      if (openTrigger) {
        e.preventDefault();
        openWishlistDrawer();
        return;
      }

      // 3. Close Drawer
      const closeTrigger = e.target.closest('[data-wishlist-close]');
      if (closeTrigger) {
        e.preventDefault();
        closeWishlistDrawer();
        return;
      }

      // 4. Remove Item from Drawer
      const removeBtn = e.target.closest('[data-wishlist-remove-handle]');
      if (removeBtn) {
        e.preventDefault();
        const handle = removeBtn.getAttribute('data-wishlist-remove-handle');
        let list = getWishlist();
        list = list.filter(item => item.handle !== handle);
        saveWishlist(list);
        return;
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeWishlistDrawer();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlist);
  } else {
    initWishlist();
  }
})();
